import { Info } from '@mui/icons-material'

import { I18n, useDevices } from 'common'
import { observer } from 'mobx-react-lite'
import { ReactElement } from 'react'
import styled from 'styled-components'
import { Config } from '../../../../../../src/config/ConfigManager'
import { ProductModel } from 'interfaces'
import { breakpoints } from '../../../../../../src/theme/breakpoints'
import { defaultTheme } from '../../../../../../src/theme/index'
import { Button } from '../../../../../../src/ui-components/forms/Button'
import { useResultsStore } from '../../../store/ResultsStore'
import { ProductCardMobile } from './ProductCardMobile'
import { ProductCardDesktop } from './ProductCardDesktop'

interface ProductCardProps {
  product: ProductModel
  alternateFor?: ProductModel
  replacementFor?: ProductModel
  green?: boolean
}

export const ProductCard = observer((props: ProductCardProps): ReactElement => {
  const { product } = props
  const { isMobileLarge } = useDevices()

  const resultsStore = useResultsStore()

  const {
    enableResortItems,
    searchByPartBin,
    searchByGfxPartBin,
    gfxLookupMade,
    setEnableResortItems,
    sortOrder,
  } = resultsStore

  const handleResort = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
    resultsStore.searchResults.parts = []
    if (gfxLookupMade) {
      searchByGfxPartBin(0)
      return
    }
    searchByPartBin(0, undefined, true)
    setEnableResortItems()
  }

  const resortOptions = ['List', 'Cost', 'Availability']

  const isEnableResortItems =
    Config.resortItemsEnabled &&
    enableResortItems?.enable &&
    enableResortItems?.lineCode === product?.lineCode &&
    enableResortItems?.partNumber === product?.partNumber &&
    enableResortItems?.description === product?.description &&
    (resortOptions.includes(sortOrder[0]?.property) ||
      resortOptions.includes(sortOrder[1]?.property))

  return (
    <>
      {isMobileLarge ? (
        <ProductCardMobile {...props} />
      ) : (
        <ProductCardDesktop {...props} />
      )}
      {!!isEnableResortItems && (
        <ReSortItemContainer>
          <TdReSort colSpan={5}>
            <LeftContainer>
              <InfoIcon />
              <p style={{ margin: 0 }}>
                <I18n name="theFollowingItemsWereLoaded" />
              </p>
            </LeftContainer>
          </TdReSort>
          <Td colSpan={1} style={{ padding: 12 }}>
            <ButtonWrapper style={{ margin: 0 }}>
              <AddButton
                onClick={() => handleResort()}
                text="resortItems"
                variant="secondary"
              />
            </ButtonWrapper>{' '}
          </Td>
        </ReSortItemContainer>
      )}
    </>
  )
})

interface TdProps {
  green?: boolean
  width?: string
}

const Td = styled.td<TdProps>`
  box-sizing: border-box;
  border-left: ${(props) =>
    props.green ? `12px solid ${defaultTheme.colors.gfxBorder}` : 'none'};
  vertical-align: top;
  padding: 16px 14px;
  max-width: ${(p) => (p.width ? `${p.width}` : '')};
`

const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  margin: 10px 0 0;
  width: 210px;
`

const AddButton = styled(Button)`
  width: 210px;
  margin-left: 0px;
  margin-right: 0px;
`

const ReSortItemContainer = styled.tr`
  width: 100%;
  background: ${defaultTheme.colors.yellowLight};
  @media screen and (max-width: ${breakpoints.mobileLarge}px) {
    display: flex;
    flex-direction: column;
    gap: 25px;
  }
`

const TdReSort = styled.td`
  padding: 12px;
  height: 60px;
  vertical-align: middle;
`

const InfoIcon = styled(Info)`
  color: ${defaultTheme.colors.yellowReSort};
  margin-right: 10px;
`

const LeftContainer = styled.div`
  width: 100%;
  min-height: auto;
  display: flex;
  align-items: center;
  font-family: Roboto;
  font-size: 16px;
  font-weight: 700;
  align-self: center;
`
